import { useEffect } from 'react';

export const useKeyPress = (key: string, callback: () => void) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // check for specified key press
      if (event.key === key) {
        callback();
      }
    };

    // listen for keydown event, and remove on cleanup
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [callback]);
};
